var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Ski Trail Rating Symbols - Black Diamond",
    viewBox: "0 0 599 599",
    width: 600,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "black_diamond",
    fill: "#000",
    d: "M 300,575 L 575,300 L 300,25 L 25,300 L 300,575 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlack);
export default __webpack_public_path__ + "static/media/black.a23ca0d784d1596c1ee762c6269c892f.svg";
export { ForwardRef as ReactComponent };